import { parseEntityRef } from '@backstage/catalog-model';

/**
 * The name shown for the signed-in user: the display name of the sign-in
 * profile (the `name` claim Authelia sends), else the name part of the user's
 * entity ref — `jdupont` for `user:default/jdupont`, never the whole ref.
 */
export function userDisplayName(
  displayName: string | undefined,
  userEntityRef: string,
): string {
  const trimmed = displayName?.trim();
  return trimmed ? trimmed : parseEntityRef(userEntityRef).name;
}

/**
 * Authelia's logout page, told to send the browser back to Backstage once the
 * Authelia session is gone.
 *
 * `/logout` is the route of Authelia's login portal that ends its SSO session;
 * `rd` is where it redirects afterwards. Authelia only follows `rd` to an
 * https URL inside one of its session cookie domains, and otherwise stays on
 * its own portal: the user is signed out either way.
 */
export function autheliaLogoutUrl(
  autheliaBaseUrl: string,
  returnTo: string,
): string {
  const url = new URL(`${autheliaBaseUrl.replace(/\/+$/, '')}/logout`);
  url.searchParams.set('rd', returnTo);
  return url.toString();
}
